import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_menu",
  "use": "icon-icon_menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_menu\"><defs><style></style></defs><path d=\"M798.72 414.72H61.44a25.6 25.6 0 0 1 0-51.2h737.28a25.6 25.6 0 0 1 0 51.2zm163.84-266.24H61.44a25.6 25.6 0 0 1 0-51.2h901.12a25.6 25.6 0 0 1 0 51.2zM634.88 680.96H61.44a25.6 25.6 0 0 1 0-51.2h573.44a25.6 25.6 0 0 1 0 51.2zM471.04 947.2H61.44a25.6 25.6 0 0 1 0-51.2h409.6a25.6 25.6 0 0 1 0 51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol